import React, { Component } from 'react';
import './feedbackTitle.css';
import {Auth} from 'aws-amplify';
import submitFeedback from '../utils/submitFeedback';

class FeedbackTitle extends Component {

  state = {
    inputType: 'Bug Report',
    inputApp: 'Basis Utilities Website',
    inputAppOther: '',
    inputPriority: 'Low',
    inputBody: '',
    status: ''
  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="FeedbackTitlePage">
        <h1>Feedback</h1>
        <div className="InputForm">
          <div className="InputRest">
            <div>
              <label htmlFor="inputType">Type: </label>
              <select id="inputType" value={this.state.inputType} name="inputType" onChange={this.handleFormInput}>
                <option value="Bug Report">Bug Report</option>
                <option value="Suggestion">Suggestion</option>
                <option value="App Request">App Request</option>
              </select>
            </div>
            <div>
              <label htmlFor="inputApp">App: </label>
              <select id="inputApp" value={this.state.inputApp} name="inputApp" onChange={this.handleFormInput}>
                <option value="Basis Utilities Website">Basis Utilities Website</option>
                <option value="Instance Screenshot Viewer">Instance Screenshot Viewer</option>
                <option value="SAP Report Website">SAP Report Website</option>
                <option value="Other">Other (Please Specify)</option>
              </select>
            </div>
            <div>
              <input className={this.state.inputApp === 'Other' ? '' : 'Hidden'} id="inputAppOther" value={this.state.inputAppOther} name="inputAppOther" onChange={this.handleFormInput}/>
            </div>
            <div>
              <label htmlFor="inputPriority">Priority: </label>
              <select id="inputPriority" value={this.state.inputPriority} name="inputPriority" onChange={this.handleFormInput}>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <button onClick={this.handleSubmit}>SUBMIT</button>
            <p>{`> ${this.state.status}`}</p>
          </div>
          <div className="InputBody">
            <label htmlFor="inputBody">Body</label>
            <textarea id="inputBody" value={this.state.inputBody} name="inputBody" onChange={this.handleFormInput}/>
          </div>
        </div>
      </div>
    );
  }

    handleFormInput = e => {
      this.setState({[e.target.id]: e.target.value, status: ''});
    }

    handleSubmit = () => {

      if (this.state.inputBody === '') {
        this.setState({status: 'Body cannot be blank.'});
      } else if (this.state.inputApp === 'Other' && this.state.inputAppOther === '') {
        this.setState({status: 'App cannot be blank.'});
      } else {
        this.setState({status: 'Sending feedback...'}, () => {

          Auth.currentAuthenticatedUser()
          .then(user => {

            const feedback = {
              user: user.username,
              type: this.state.inputType,
              app: this.state.inputApp !== 'Other' ? this.state.inputApp : this.state.inputAppOther,
              priority: this.state.inputPriority,
              date: Date.now(),
              body: this.state.inputBody,
              status: [
                {
                  status: 'Unanswered',
                  date: Date.now(),
                  body: 'Feedback created.'
                }
              ]
            };

            return submitFeedback(feedback);

          })
          .then(res => {
            this.setState({status: 'Feedback sent.'});
            this.props.handleDownloadingFeedback();
          })
          .catch(err => {
            this.setState({status: 'Feedback failed to submit.'});
            console.log(err);
          });

        });
      }

    }

}

export default FeedbackTitle;


// WEBPACK FOOTER //
// ./src/components/content/feedback/feedbackTitle/feedbackTitle.js